import {useEffect, useState} from 'react'

export const LoadingStates = {
  loaded: 'loaded',
  missing: 'missing',
  loading: 'loading',
} as const
export type LoadingStates = ObjectValues<typeof LoadingStates>

export function useViewLoadingState() {
  const [isLoading, setIsLoading] = useState(false)
  // TODO: https://github.com/github/projects-platform/issues/3414
  const missingRequiredColumnData = false

  useEffect(() => {
    if (!missingRequiredColumnData) return
    let mounted = true
    const timeout = window.setTimeout(() => {
      if (mounted) {
        setIsLoading(true)
      }
    }, 300)

    return () => {
      mounted = false
      window.clearTimeout(timeout)
    }
  }, [missingRequiredColumnData])

  useEffect(() => {
    if (!missingRequiredColumnData && isLoading) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsLoading(false)
    }
  }, [isLoading, missingRequiredColumnData])

  if (isLoading && missingRequiredColumnData) return {loadingState: LoadingStates.loading} as const
  if (missingRequiredColumnData) return {loadingState: LoadingStates.missing} as const
  return {loadingState: LoadingStates.loaded} as const
}
